module.exports = __webpack_public_path__ + "static/media/h4.a48ff6b1.svg";